import React from 'react';
import { Button } from "reactstrap";
import { formateDateandTime } from "../../../../helpers/formats.js";

const FotoCard = ({ foto, altText }) => {
    if (!foto) return null;

    const isPdf = foto.nomeArquivo.split('.').pop().toLowerCase() === "pdf";
    const imgSrc = isPdf ? require("assets/img/document-ok.png") : foto.nomeArquivo;

    return (
        <div className="foto-card-premium mb-2">
            <div className="foto-img-wrapper">
                <img 
                    src={imgSrc} 
                    alt={altText || "Foto"}
                    style={{ cursor: "pointer" }} 
                    onClick={() => window.open(foto.nomeArquivo, "_blank")} 
                />
            </div>

            <div className="foto-info">
                {foto.dataHoraArquivo && (
                    <div className="foto-meta-item">
                        <i className="far fa-clock foto-meta-icon"></i> 
                        <span><strong>Data:</strong> {formateDateandTime(foto.dataHoraArquivo)}</span>
                    </div>
                )}
                {foto.geoLocalizacao && (
                    <>
                        <div className="foto-meta-item text-truncate" title={foto.geoLocalizacao}>
                            <i className="fas fa-map-marker-alt foto-meta-icon"></i> 
                            <span><strong>Lat/Long:</strong> {foto.geoLocalizacao.replace(';', ', ')}</span>
                        </div>
                        <Button 
                            color="success" 
                            size="sm" 
                            block
                            className="btn-maps-premium"
                            onClick={() => window.open(`https://www.google.com/maps?q=${foto.geoLocalizacao.replace(';', ',')}`, "_blank")}
                        >
                            <i className="fas fa-external-link-alt mr-1"></i> Ver no Google Maps
                        </Button>
                    </>
                )}
            </div>
        </div>
    );
};

export default FotoCard;
